import { ReactComponent as NewFilter } from '@assets/svg/new-filter.svg';
import { GlobalOverlay } from '@components';
import { ClickAwayListener } from '@material-ui/core';
import { useState as classicUseState } from 'react';
import { CSSTransition } from 'react-transition-group';

import { MenuContent } from './components';

import { Block, Container, ContainerSidebar } from './Menu.styles';

interface IMenu {
  filterCount: number;
  startSearch: () => void;
}
const Menu = ({ filterCount, startSearch }: IMenu) => {
  const [open, setOpen] = classicUseState(false);

  const handleClickAway = () => {
    if (open) setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Container>
        <ContainerSidebar
          onClick={() => {
            setOpen(!open);
          }}
        >
          <NewFilter />
          {open && <GlobalOverlay onClick={handleClickAway} />}
        </ContainerSidebar>

        <CSSTransition
          in={open}
          timeout={300}
          classNames="my-node"
          unmountOnExit
          onEnter={() => setOpen(true)}
          onExited={() => setOpen(false)}
        >
          <Block>
            <MenuContent
              setOpenMenu={setOpen}
              filterCount={filterCount}
              startSearch={startSearch}
            />
          </Block>
        </CSSTransition>
      </Container>
    </ClickAwayListener>
  );
};

export { Menu };
